module.exports = __webpack_public_path__ + "img/science-bg.108c2fa9.png";